"use client";

import { useState } from "react";

import { Response } from "@/components/ui/shadcn-io/ai/response";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

const INSTRUCTIONS_PLACEHOLDER = `## Steps
1. …
2. …

## Rules
- …`;

interface SkillMarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  id?: string;
}

export function SkillMarkdownEditor({
  value,
  onChange,
  maxLength = 100_000,
  id,
}: SkillMarkdownEditorProps) {
  const [mobileTab, setMobileTab] = useState<"edit" | "preview">("edit");

  return (
    <div className="space-y-2">
      <div className="flex gap-1 md:hidden">
        {(["edit", "preview"] as const).map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setMobileTab(tab)}
            className={cn(
              "rounded-full px-3 py-1 text-xs font-medium capitalize",
              mobileTab === tab
                ? "bg-primary text-primary-foreground"
                : "bg-muted text-muted-foreground",
            )}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        <Textarea
          id={id}
          value={value}
          onChange={(event) => onChange(event.target.value.slice(0, maxLength))}
          placeholder={INSTRUCTIONS_PLACEHOLDER}
          className={cn(
            "min-h-[280px] resize-y font-mono text-[13px] leading-relaxed",
            mobileTab === "preview" && "hidden md:block",
          )}
        />
        <div
          className={cn(
            "min-h-[280px] overflow-auto rounded-xl border border-border bg-muted/30 p-4",
            mobileTab === "edit" && "hidden md:block",
          )}
        >
          {value.trim() ? (
            <Response className="text-sm">{value}</Response>
          ) : (
            <p className="text-sm text-muted-foreground">Preview appears as you write.</p>
          )}
        </div>
      </div>
      <p className="text-right text-[11px] text-muted-foreground">
        {value.length.toLocaleString()} / {maxLength.toLocaleString()}
      </p>
    </div>
  );
}
